import React from "react";

const CollectionsReport = () => (
  <div>
    <h2>Revenue Report</h2>
    <p>Details and charts for the revenue report will be displayed here.</p>
  </div>
);

export default CollectionsReport;
